/* Liveniaderm — Hydrogel DE landing : galerie + vidéo, offres, ajout panier, barre sticky, accordéons, scroll. */
(function(){
  var root = document.querySelector('[data-lv-hero]');
  var sticky = document.querySelector('.lv-hy-sticky');

  // ---- accordéons FAQ (toutes sections) ----
  document.querySelectorAll('.lv-hy .bs-acc-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var acc = btn.closest('.bs-acc');
      var open = acc.classList.toggle('is-open');
      var sign = acc.querySelector('.bs-acc-sign');
      if(sign) sign.textContent = open ? '−' : '+';
    });
  });

  // ---- scroll vers les offres ----
  function goPlans(){ var el=document.getElementById('bundles'); if(!el) return; window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 90, behavior:'smooth' }); }
  document.querySelectorAll('[data-scroll-plans]').forEach(function(b){ b.addEventListener('click', function(e){ if(e&&e.preventDefault)e.preventDefault(); goPlans(); }); });

  if(!root) return;

  // ---- galerie : vignettes + vidéo en première slide ----
  var gmain = root.querySelector('[data-gmain]');
  var gvwrap = root.querySelector('[data-gvwrap]');
  var gvideo = root.querySelector('[data-gvideo]');
  var gvsound = root.querySelector('[data-gvsound]');
  var gvActive = !!gvwrap, gvInView = true;
  function gvPlay(){ if(gvideo){ var p = gvideo.play(); if(p && p.catch) p.catch(function(){}); } }
  function showVideo(on){
    if(!gvwrap || !gvideo) return;
    gvActive = on; gvwrap.style.display = on ? 'block' : 'none';
    if(on && gvInView){ gvPlay(); } else { gvideo.pause(); }
  }
  if(gvideo && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ gvInView = en[0].isIntersecting; if(gvActive && gvInView){ gvPlay(); } else { gvideo.pause(); } }, {threshold:0.25}).observe(gvwrap);
  }
  root.querySelectorAll('[data-gthumb]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.hasAttribute('data-video')){ showVideo(true); }
      else { showVideo(false); var src = btn.getAttribute('data-src'); if(gmain && src){ gmain.src = src; gmain.removeAttribute('srcset'); } }
      root.querySelectorAll('[data-gthumb]').forEach(function(b){ b.style.borderColor = (b===btn) ? '#381932' : 'transparent'; });
    });
  });
  if(gvsound && gvideo){
    gvsound.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      gvideo.muted = !gvideo.muted;
      gvsound.querySelector('[data-ico-muted]').style.display = gvideo.muted ? '' : 'none';
      gvsound.querySelector('[data-ico-sound]').style.display = gvideo.muted ? 'none' : '';
    });
  }

  // ---- date d'expédition (jours ouvrés) ----
  root.querySelectorAll('[data-ship-date]').forEach(function(el){
    var d = new Date(), add = parseInt(el.getAttribute('data-ship-date'),10) || 1;
    while(add > 0){ d.setDate(d.getDate()+1); if(d.getDay()!==0 && d.getDay()!==6) add--; }
    try { el.textContent = d.toLocaleDateString(el.getAttribute('data-locale') || 'de-DE', {weekday:'short', day:'numeric', month:'short'}); } catch(e){}
  });

  // ---- sélection d'offre ----
  function selectPlan(btn){
    root.querySelectorAll('.lz-plan').forEach(function(b){ b.classList.toggle('is-active', b===btn); });
    var v = btn.getAttribute('data-variant'), price = btn.getAttribute('data-price'), dur = btn.getAttribute('data-dur'), cmp = btn.getAttribute('data-cmp') || '';
    var add = root.querySelector('.lz-addbtn'), ctaPrice = root.querySelector('[data-cta-price]');
    if(add && v) add.setAttribute('data-add-variant', v);
    if(ctaPrice && price) ctaPrice.textContent = price;
    if(sticky){
      var sa = sticky.querySelector('[data-sticky-add]'), sp = sticky.querySelector('[data-sticky-price]'), sc = sticky.querySelector('[data-sticky-cmp]'), st = sticky.querySelector('[data-sticky-title]');
      if(sa && v) sa.setAttribute('data-add-variant', v);
      if(sp && price) sp.textContent = price;
      if(sc){ sc.textContent = cmp; sc.style.display = cmp ? '' : 'none'; }
      if(st && dur) st.textContent = dur;
    }
  }
  root.querySelectorAll('.lz-plan').forEach(function(b){ b.addEventListener('click', function(){ selectPlan(b); }); });
  var initActive = root.querySelector('.lz-plan.is-active') || root.querySelector('.lz-plan');
  if(initActive) selectPlan(initActive);

  // ---- ajout au panier (Ajax natif Shopify, puis tiroir du thème ou page panier) ----
  var cartAdd = root.getAttribute('data-cart-add') || '/cart/add';
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  function addToCart(btn){
    var id = btn.getAttribute('data-add-variant'); if(!id) return;
    btn.setAttribute('disabled','');
    fetch(cartAdd + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id: parseInt(id,10), quantity: 1}]})})
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        var drawer = document.querySelector('cart-drawer#cart-drawer, cart-drawer, cart-notification-drawer');
        if(drawer && typeof drawer.show === 'function' && drawer.tagName.toLowerCase() === 'cart-drawer'){ drawer.show(); }
        else { window.location.href = cartUrl; }
      })
      .catch(function(){ window.location.href = cartUrl; })
      .finally(function(){ btn.removeAttribute('disabled'); });
  }
  document.querySelectorAll('[data-add-variant]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); addToCart(b); }); });

  // ---- barre sticky : visible après 800 px, cachée quand le bloc d'achat est à l'écran ----
  if(sticky){
    var offer = document.getElementById('lz-offer'), offerVis = false;
    function upd(){ sticky.classList.toggle('bs-show', (window.pageYOffset||0) > 800 && !offerVis); }
    if(offer && 'IntersectionObserver' in window){ new IntersectionObserver(function(e){ offerVis = e[0].isIntersecting; upd(); }, {threshold:0.04}).observe(offer); }
    window.addEventListener('scroll', upd, {passive:true}); window.addEventListener('resize', upd); upd();
  }
})();
